// <s-gallery-sync> — Moves the product gallery slideshow to the selected variant's image.
// Rendered inside the 'product-form' partial, so s-variant-picker's partial swap reconnects a
// fresh element after every variant change. Reads:
//   target       — id of the <s-slideshow> to drive (e.g. "slideshow-product-gallery").
//   media-index  — zero-based slide index of the variant's featured media (empty = no change).
class GalleryVariantSync extends HTMLElement {
  async connectedCallback() {
    const index = Number.parseInt(this.getAttribute('media-index') ?? '', 10);
    const targetId = this.getAttribute('target');
    if (Number.isNaN(index) || index < 0 || !targetId) return;

    await customElements.whenDefined('s-slideshow');
    if (!this.isConnected) return;

    const slideshow = document.getElementById(targetId);
    if (slideshow && typeof slideshow.select === 'function') {
      slideshow.select(index);
    }
  }
}

if (!customElements.get('s-gallery-sync')) {
  customElements.define('s-gallery-sync', GalleryVariantSync);
}
